import React from 'react';
import EmptyState from 'ats/components/empty-state/EmptyState';
import { EMPTY_STATE_ICONS } from 'ats/components/empty-state/emptyStateIcons';

export default function SettingsListEmptyState({
	entityPlural,
	hasFilters,
	onClearFilters
}) {
	return (
		<EmptyState
			size="sm"
			icon={
				hasFilters ? EMPTY_STATE_ICONS.noResults : EMPTY_STATE_ICONS.candidate
			}
			iconAlt={
				hasFilters ? `No matching ${entityPlural}` : `No ${entityPlural} yet`
			}
			message={
				hasFilters
					? `No ${entityPlural} match your search criteria.`
					: `No ${entityPlural} added yet.`
			}
			detail={
				hasFilters
					? 'Try adjusting your filters or search terms to see more results.'
					: undefined
			}
			actionText={hasFilters ? 'Clear filters' : undefined}
			onActionClick={hasFilters ? onClearFilters : undefined}
		/>
	);
}
